import React from "react"
import Header from '../components/Header';
import Footer from '../components/Footer';
import Introduction from '../components/Introduction';
import ContentArea from '../components/common/ContentArea';
import About from '../components/About';
import Skill from '../components/Skill';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import {Helmet} from "react-helmet";
import ScrollAnimation from 'react-animate-on-scroll';
import '../tailwind.css';

export default function App() {
  return <div className='w-screen h-screen tracking-wide'>
    <Helmet>
      <meta charSet="utf-8" />
      <title>AnnoRyoya's Work</title>
      {/* import AdobeFonts */}
      <link rel="stylesheet" href="https://use.typekit.net/wrq6syh.css"></link>
      {/* import animate.css */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"></link>
    </Helmet>
    <Header/>
    <Introduction/>
    <ScrollAnimation animateIn='bounceInRight' animateOut='bounceOutLeft' animateOnce={true}>
      <span id='ABOUT'><ContentArea label='ABOUT' Content={About}/></span>
    </ScrollAnimation>
    <ScrollAnimation animateIn='bounceInRight' animateOut='bounceOutLeft' animateOnce={true}>
      <span id='SKILL'><ContentArea label='SKILL' Content={Skill}/></span>
    </ScrollAnimation>
    <ScrollAnimation animateIn='bounceInRight' animateOut='bounceOutLeft' animateOnce={true}>
      <span id='PROJECTS'><ContentArea label='PROJECTS' Content={Projects}/></span>
    </ScrollAnimation>
    <ScrollAnimation animateIn='bounceInRight' animateOut='bounceOutLeft' animateOnce={true}>
      <span id='CONTACT'><ContentArea label='CONTACT' Content={Contact}/></span>   
    </ScrollAnimation>
    <Footer/> 
  </div>
}
